import BackendService from './BackendService';

export default class RoleService {
  static getRoles() {
    return BackendService.get('/permissions/all');
  }

  static getResources() {
    return BackendService.get('/permissions/resources');
  }

  static getRole(role) {
    return BackendService.get(`/permissions/${role}`);
  }

  static createRole(role) {
    return BackendService.post('/permissions/', { body: role });
  }

  static updateRole(role) {
    return BackendService.put(`/permissions/${role.role}`, {
      body: role,
    });
  }

  static deleteRole(roleId) {
    return BackendService.delete(`/permissions/${roleId}`);
  }
}
